import {Tag, Card, message, Row, Button, Typography} from "antd";
import {Component} from "react";
import "../asset/style/auditlog/auditlogdumptile.css"
import axios from "axios";
import {AuthHeader} from "../configs/auth.token";
import {getStateAwareUrl} from "../utils/utils";

class AuditLogDumpTile extends Component {
    downloadFile = (response) => {
        const url = window.URL.createObjectURL(new Blob([response.data], {"type": "application/zip"}))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', "audit_log_dump.zip")
        document.body.appendChild(link)
        link.click()
        link.remove()
    }

    downloadAuditLogDump = () => {
        const url = getStateAwareUrl(`/api/get_audit_log_file/?id=${this.props.id}`)
        axios.get(url, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/zip',
                'Authorization': AuthHeader()
            }
        }).then((response) => {
            this.downloadFile(response)
        }).catch(err => {
            message.error("Some error occurred. Not able to download");
        })
    }


    render() {
        let year, date, timezone;
        if (this.props.status === "COMPLETED") {
            const date_split = this.props.created_at.split("T")
            year = date_split[0]
            date = date_split[1]
            timezone = date.split("+")[1]
        }
        const users = [];
        if (this.props.data.all_users) {
            users.push("All users are selected")
        } else {
            this.props.data.user_names.forEach(username => {
                if (username.length > 6) {
                    users.push(username.slice(0, 6) + "..")
                } else {
                    users.push(username);
                }
            })
        }


        return <Card className={"card"} title={<Typography>
            {"Audit Log Dump"}
            {this.props.status === "COMPLETED" &&
                <Button type="primary" ghost shape="round" icon="download" size="16px"
                        style={{float: "right"}}
                        onClick={this.downloadAuditLogDump}/>}
            {this.props.status === "PENDING" &&
                <Button type="primary" ghost shape="round" icon="download" size="16px"
                        style={{float: "right"}}
                        disabled={true}/>}
            {this.props.status === "ERROR" &&
                <Button shape="round" ghost icon="stop" size="16px"
                        style={{float: "right", backgroundColor: "red", color: "white"}}
                        disabled={true}
                />}
        </Typography>} bordered={true} style={{borderRadius: "20px"}}>
            <Row>
                <b>Filters you applied</b>
            </Row>
            <Row>
                <b> Start Date</b> - <i>{this.props.data.start_date}</i>
            </Row>
            <Row>
                <b>End Date </b>- <i>{this.props.data.end_date}</i>
            </Row>
            <Row style={{minHeight: "40px"}}>
                <b>Created On</b> : {this.props.status === "COMPLETED" && <span>
                    <i>{year}</i>  <div><i>{date.slice(0, 8)}{"+"}{timezone}</i></div></span>}
                {this.props.status === "PENDING" && <i>pending</i>}
            </Row>
            <Row style={{height: "50px", overflow: "hidden"}}>
                <b>Users </b>: {users.map(username => <Tag color="blue"
                                                           style={{"marginTop": "2px"}}>{username}</Tag>)}
            </Row>
        </Card>
    }

}

export default AuditLogDumpTile;